import {cloneDeep as _cloneDeep} from 'lodash';
import MeetingResultsModel from "./../../models/MeetingResultsModel"
const MeetingResultsModule = {
    namespaced: true,
    state: () => ({
        meetingResults: [],
        meetingResult: _cloneDeep(MeetingResultsModel, true),
    }),
    getters: {
        getMeetingResults (state) {
            return state.meetingResults
        },
        getMeetingResult (state) {
            return state.meetingResult
        },
    },
    mutations: {
        setMeetingResults (state, payload) {
            state.meetingResults = payload
        },
        setMeetingResult (state, payload) {
            state.meetingResult = payload
        },
    },
    actions: {
        setMeetingResults (context, payload) {
            context.commit('setMeetingResults', payload);
        },
        setMeetingResult (context, payload) {
            context.commit('setMeetingResult', payload);
        },
    },

}

export default MeetingResultsModule;
